// Copyright 2021 The Casdoor Authors. All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import * as Setting from "../conf/Setting";

export function getSyncers(owner, page = "", pageSize = "", field = "", value = "", sortField = "", sortOrder = "") {
  return fetch(`${Setting.ServerUrl}/api/get-syncers?owner=${owner}&p=${page}&pageSize=${pageSize}&field=${field}&value=${value}&sortField=${sortField}&sortOrder=${sortOrder}`, {
    method: "GET",
    credentials: "include",
  }).then(res => res.json());
}

export function getSyncer(owner, name) {
  return fetch(`${Setting.ServerUrl}/api/get-syncer?id=${owner}/${encodeURIComponent(name)}`, {
    method: "GET",
    credentials: "include",
  }).then(res => res.json());
}

export function updateSyncer(owner, name, syncer) {
  const newSyncer = Setting.deepCopy(syncer);
  return fetch(`${Setting.ServerUrl}/api/update-syncer?id=${owner}/${encodeURIComponent(name)}`, {
    method: "POST",
    credentials: "include",
    body: JSON.stringify(newSyncer),
  }).then(res => res.json());
}

export function addSyncer(syncer) {
  const newSyncer = Setting.deepCopy(syncer);
  return fetch(`${Setting.ServerUrl}/api/add-syncer`, {
    method: "POST",
    credentials: "include",
    body: JSON.stringify(newSyncer),
  }).then(res => res.json());
}

export function deleteSyncer(syncer) {
  const newSyncer = Setting.deepCopy(syncer);
  return fetch(`${Setting.ServerUrl}/api/delete-syncer`, {
    method: "POST",
    credentials: "include",
    body: JSON.stringify(newSyncer),
  }).then(res => res.json());
}

export function runSyncer(owner, name) {
  return fetch(`${Setting.ServerUrl}/api/run-syncer?id=${owner}/${encodeURIComponent(name)}`, {
    method: "GET",
    credentials: "include",
  }).then(res => res.json());
}

/* 上游同步任务接口 */

export function getUpstreamSyncerByOwner(owner) {
  return fetch(`${Setting.ServerUrl}/api/get-sync-upstreams?organUid=${owner}`, {
    method: "GET",
    credentials: "include",
  }).then(res => res.json());
}

export function getUpstreamSyncerById(id, owner) {
  return fetch(`${Setting.ServerUrl}/api/get-sync-upstream?id=${owner}/${id}`, {
    method: "GET",
    credentials: "include",
  }).then(res => res.json());
}

export function getLocalName(type) {
  return fetch(`${Setting.ServerUrl}/api/get-localName-map?type=${type}`, {
    method: "GET",
    credentials: "include",
  }).then(res => res.json());
}

export function addUpstreamSyncer(syncer) {
  const newSyncer = Setting.deepCopy(syncer);
  return fetch(`${Setting.ServerUrl}/api/add-sync-upstream`, {
    method: "POST",
    credentials: "include",
    body: JSON.stringify(newSyncer),
  }).then(res => res.json());
}

export function updateUpstreamSyncer(id, owner, syncer) {
  const newSyncer = Setting.deepCopy(syncer);
  return fetch(`${Setting.ServerUrl}/api/update-sync-upstream?id=${owner}/${id}`, {
    method: "POST",
    credentials: "include",
    body: JSON.stringify(newSyncer),
  }).then(res => res.json());
}

export function deleteUpstreamSyncer(syncer) {
  const newSyncer = Setting.deepCopy(syncer);
  return fetch(`${Setting.ServerUrl}/api/delete-sync-upstream`, {
    method: "POST",
    credentials: "include",
    body: JSON.stringify(newSyncer),
  }).then(res => res.json());
}

export function testUpstreamSync(syncer) {
  const controller = new AbortController();

  const newSyncer = Setting.deepCopy(syncer);
  // 如果10秒钟没有响应则超时
  setTimeout(() => {
    controller.abort();
  }, 10000);
  return fetch(`${Setting.ServerUrl}/api/test-sync-upstream-conf`, {
    method: "POST",
    credentials: "include",
    signal: controller.signal,
    body: JSON.stringify(newSyncer),
  }).then(res => res.json());
}

export function doUpstreamSync(id, owner) {
  return fetch(`${Setting.ServerUrl}/api/do-sync-upstream?id=${owner}/${id}`, {
    method: "GET",
    credentials: "include",
  }).then(res => res.json());
}

export function getUpstreamSyncerLog(syncUid, page, pageSize, field = "", value = "", sortField = "", sortOrder = "") {
  return fetch(`${Setting.ServerUrl}/api/get-syncer-upstream-logs?syncUid=${syncUid}&pageSize=${pageSize}&p=${page}&field=${field}&value=${value}&sortField=${sortField}&sortOrder=${sortOrder}`, {
    method: "GET",
    credentials: "include",
  }).then(res => res.json());
}

export function getUpstreamSyncerLogDetail(syncUid, logUid, page, pageSize, field = "", value = "", sortField = "", sortOrder = "") {
  return fetch(`${Setting.ServerUrl}/api/get-syncer-upstream-logs-details?syncUid=${syncUid}&logUid=${logUid}&pageSize=${pageSize}&p=${page}&field=${field}&value=${value}&sortField=${sortField}&sortOrder=${sortOrder}`, {
    method: "GET",
    credentials: "include",
  }).then(res => res.json());
}

/* 上游同步任务接口 */

/* 下游同步任务接口 */

export function getDownstreamSyncerByOwner(owner) {
  return fetch(`${Setting.ServerUrl}/api/get-sync-downstreams?organUid=${owner}`, {
    method: "GET",
    credentials: "include",
  }).then(res => res.json());
}

export function getDownstreamSyncerById(id, owner) {
  return fetch(`${Setting.ServerUrl}/api/get-sync-downstream?id=${owner}/${id}`, {
    method: "GET",
    credentials: "include",
  }).then(res => res.json());
}

export function addDownstreamSyncer(syncer) {
  const newSyncer = Setting.deepCopy(syncer);
  return fetch(`${Setting.ServerUrl}/api/add-sync-downstream`, {
    method: "POST",
    credentials: "include",
    body: JSON.stringify(newSyncer),
  }).then(res => res.json());
}

export function updateDownstreamSyncer(id, owner, syncer) {
  const newSyncer = Setting.deepCopy(syncer);
  return fetch(`${Setting.ServerUrl}/api/update-sync-downstream?id=${owner}/${id}`, {
    method: "POST",
    credentials: "include",
    body: JSON.stringify(newSyncer),
  }).then(res => res.json());
}

export function deleteDownstreamSyncer(syncer) {
  const newSyncer = Setting.deepCopy(syncer);
  return fetch(`${Setting.ServerUrl}/api/delete-sync-downstream`, {
    method: "POST",
    credentials: "include",
    body: JSON.stringify(newSyncer),
  }).then(res => res.json());
}

/* 下游同步任务接口 */

export function updateUpstreamSyncerOrder(list) {
  const obj = {
    SyncerUpstreamOrders: list,
  };
  return fetch(`${Setting.ServerUrl}/api/update-sync-upstream-order?`, {
    method: "POST",
    credentials: "include",
    body: JSON.stringify(obj),
  }).then(res => res.json());
}
